import { createSlice } from "@reduxjs/toolkit";
import {
  extraReducers,
  initialState,
  reducers,
} from "./reducers/featuresReducers";

export const FeaturesSlice = createSlice({
  name: "features",
  initialState,
  reducers,
  extraReducers,
});

export default FeaturesSlice.reducer;
